/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import head from 'lodash/head';

import { useAlert } from '../../../Common/hooks';
import { getBusinessFilters } from '../../selectors';
import { getBusinessReports } from '../../services';

const useBusinessSummary = () => {
  const filters = useSelector(getBusinessFilters);
  const { showAlert } = useAlert();
  const [isFirstMount, setIsFirstMount] = useState(true);
  const [businessReports, setBusinessReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleFilterChange = async () => {
    setIsLoading(true);
    const response = await getBusinessReports(filters);

    if (response.errors?.length > 0) {
      const errorMessage = head(response.errors);
      showAlert({ color: 'error', icon: 'exclamation', message: errorMessage });

      return;
    }

    setBusinessReports(response.business);
    setIsLoading(false);
  };

  useEffect(() => {
    if (isFirstMount) {
      setIsFirstMount(false);

      return;
    }
    handleFilterChange();
  }, [filters]);

  return {
    businessReports,
    isLoading,
    handleFilterChange,
  };
};

export default useBusinessSummary;
